import { render, staticRenderFns } from "./SettingsPersonal.vue?vue&type=template&id=14601cdb&scoped=true&"
import script from "./SettingsPersonal.vue?vue&type=script&lang=js&"
export * from "./SettingsPersonal.vue?vue&type=script&lang=js&"
import style0 from "./SettingsPersonal.vue?vue&type=style&index=0&id=14601cdb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14601cdb",
  null
  
)

export default component.exports